
import { useState } from 'react';
import Hero from './components/Hero';
import Products from './components/Products';
import Gallery from './components/Gallery';
import Features from './components/Features';
import Pricing from './components/Pricing';
import CTA from './components/CTA';
import OrderForm from './components/OrderForm';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Contact from './components/Contact';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Products />
      <Gallery />
      <Pricing />
      <CTA />
      <OrderForm />
      <Features />
      <Contact />
      <Footer />
    </div>
  );
}
